import { Component, OnInit, HostListener } from '@angular/core';
import {
	NavigationService,
	IMenuItem,
	IChildItem,
} from '../../../../services/navigation.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Utils } from '../../../../utils';
import { SecurityService } from '../../../../services/secutiry.service';
import { AuthService } from '../../../../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { initType } from '../../../../../app.constants';
import { ConfiguracionDiseno } from 'src/app/shared/models/configuraciondiseno.model';
import { ConfiguracionDisenoService } from 'src/app/shared/services/configuraciondiseno.service';
import { ConfiguracionPagoClientesService } from 'src/app/shared/services/configuracionpagoclientes.service';
import {
	PORTAL_DEFAULT_MENU,
	PORTAL_IMPLEMENTATION_MENU,
	PORTAL_PAYMENT_MENU,
} from 'src/app/shared/constants/portal-menu.constants';
import { LocalStoreService } from 'src/app/shared/services/local-store.service';

@Component({
	selector: 'app-sidebar-compact',
	templateUrl: './sidebar-compact.component.html',
	styleUrls: ['./sidebar-compact.component.scss'],
})
export class SidebarCompactComponent implements OnInit {
	selectedItem: IMenuItem;
	public configDiseno: ConfiguracionDiseno = new ConfiguracionDiseno();
	nav: IMenuItem[];

	private defaultMenu: IMenuItem[] = JSON.parse(
		JSON.stringify(PORTAL_DEFAULT_MENU),
	); // = PORTAL_DEFAULT_MENU;

	private paymentMenu: IMenuItem[] = JSON.parse(
		JSON.stringify(PORTAL_PAYMENT_MENU),
	);

	private implementationMenu: IMenuItem[] = JSON.parse(
		JSON.stringify(PORTAL_IMPLEMENTATION_MENU),
	);

	constructor(
		public router: Router,
		public navService: NavigationService,
		private spinner: NgxSpinnerService,
		private securityService: SecurityService,
		private authService: AuthService,
		private configuracionService: ConfiguracionPagoClientesService,
		private ls: LocalStoreService,
	) {}

	ngOnInit() {
		this.updateSidebar();
		// CLOSE SIDENAV ON ROUTE CHANGE
		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe((routeChange) => {
				this.closeChildNav();
				if (Utils.isMobile()) {
					this.navService.sidebarState.sidenavOpen = false;
				}
			});

		if (initType() == 'PAYMENT') {
			this.nav = this.paymentMenu;
			this.setActiveFlag();
		} else {
			const user = this.authService.getuser();

			if (user != null) {
				const configuracionCompletaPortal =
					this.configuracionService.getAllConfiguracionPortalLs();
				if (configuracionCompletaPortal != null) {
					this.configDiseno =
						configuracionCompletaPortal.configuracionDiseno;
				}

				const cachedNav = this.ls.getItem('portal_nav');
				if (
					cachedNav &&
					Array.isArray(cachedNav) &&
					cachedNav.length > 0
				) {
					this.nav = cachedNav;
					this.setActiveFlag();
					return;
				}

				const role = (this.authService.getRole() ?? '').toLowerCase();
				if (!role) {
					this.authService.signout();
					return;
				}
				const isImplementador = role === 'implementador';

				this.securityService.getPermisosByEmail().subscribe(
					(res) => {
						if (isImplementador) {
							this.implementationMenu.forEach((menu) => {
								if (menu.id != null) {
									let added = res.find(
										(x) => x.idAcceso == menu.id,
									);
									if (added != null) {
										menu.visible = true;
									} else {
										menu.visible = false;
									}

									menu.sub.forEach((submenu) => {
										let added = res.find(
											(x) => x.idAcceso == submenu.id,
										);
										if (added != null) {
											submenu.visible = true;
										} else {
											submenu.visible = false;
										}
									});
								} else {
									menu.visible = true;
								}
							});

							let newMenu: any = [];

							this.implementationMenu.forEach((element) => {
								if (element.visible) {
									let sm = element.sub.filter(
										(x) => x.visible == true,
									);
									if (sm && sm.length > 0) {
										element.sub = Object.assign([], sm);
									} else {
										if (element.id != null) {
											element.sub = [];
										}
									}

									newMenu.push(element);
								}
							});

							this.nav = newMenu;
							this.setActiveFlag();
						} else {
							this.defaultMenu.forEach((menu) => {
								if (menu.id != null) {
									let added = res.find(
										(x) => x.idAcceso == menu.id,
									);
									if (added != null) {
										menu.visible = true;
									} else {
										menu.visible = false;
									}

									menu.sub.forEach((submenu) => {
										let added = res.find(
											(x) => x.idAcceso == submenu.id,
										);
										// if (added != null) {
										submenu.visible = true;
										// } else {
										// submenu.visible = false;
										// }
									});
								} else {
									menu.visible = true;
								}
							});

							let newMenu: any = [];

							this.defaultMenu.forEach((element) => {
								if (element.visible) {
									let sm = element.sub.filter(
										(x) => x.visible == true,
									);
									if (sm && sm.length > 0) {
										element.sub = Object.assign([], sm);
									} else {
										if (element.id != null) {
											element.sub = [];
										}
									}

									newMenu.push(element);
								}
							});

							this.nav = newMenu;
							this.setActiveFlag();
						}
					},
					(err) => {
						this.spinner.hide();
					},
				);
			}
		}
	}

	selectItem(item) {
		this.navService.sidebarState.childnavOpen = true;
		this.selectedItem = item;
		this.setActiveMainItem(item);
	}

	closeChildNav() {
		this.navService.sidebarState.childnavOpen = false;
		this.setActiveFlag();
	}

	onClickChangeActiveFlag(item) {
		this.setActiveMainItem(item);
	}

	setActiveMainItem(item) {
		this.nav.forEach((item) => {
			item.active = false;
		});
		item.active = true;
	}

	setActiveFlag() {
		if (window && window.location) {
			const activeRoute =
				window.location.hash || window.location.pathname;
			this.nav.forEach((item) => {
				item.active = false;
				if (activeRoute.indexOf(item.state) !== -1) {
					this.selectedItem = item;
					item.active = true;
				}
				if (item.sub) {
					item.sub.forEach((subItem) => {
						subItem.active = false;
						if (activeRoute.indexOf(subItem.state) !== -1) {
							this.selectedItem = item;
							item.active = true;
							// subItem.active = true;
							// debugger;
						}
						if (subItem.sub) {
							subItem.sub.forEach((subChildItem) => {
								if (
									activeRoute.indexOf(subChildItem.state) !==
									-1
								) {
									this.selectedItem = item;
									item.active = true;
									subItem.active = true;
								}
							});
						}
					});
				}
			});
		}
	}

	updateSidebar() {
		if (Utils.isMobile()) {
			this.navService.sidebarState.sidenavOpen = false;
			this.navService.sidebarState.childnavOpen = false;
		} else {
			this.navService.sidebarState.sidenavOpen = true;
		}
	}

	toggelSidebar() {
		const state = this.navService.sidebarState;
		state.sidenavOpen = !state.sidenavOpen;
		state.childnavOpen = !state.childnavOpen;
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		this.updateSidebar();
	}
}
